// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__32ajs","message":"styles_message__yqVi2","error":"styles_error__1W_nR","error_align-right":"styles_error_align-right__3oyh_"};